__turbopack_context__.v({
  "ButtonWrapper": "kCYRTa_ButtonWrapper",
  "Container": "kCYRTa_Container",
  "Content": "kCYRTa_Content",
  "Description": "kCYRTa_Description",
  "MobileText": "kCYRTa_MobileText",
  "Root": "kCYRTa_Root",
  "TextWrapper": "kCYRTa_TextWrapper",
  "Title": "kCYRTa_Title",
});
